import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "D:/git/misce/carbon/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Mermaid from "../components/Mermaid.js";
import { wp5 } from "../workplan/tasks.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`WP5 is focused on dissemination activities. The main expectation from this WP is to ensure as wide as possible an impact
for the project activities and results. The initial activities will be with the aim to design the dissemination plan, to define the
most effective dissemination channels, and to define common procedures to support the creation of a contacts network, a
wide range of users from universities and the private sector.`}</p>
      <p>{`All the partners will contribute to international dissemination activities and local actions, according to their skills
and contacts. Partners will commit to exploring ways to disseminate findings from the project and related research through
the project website and regular electronic bulletins, as well as via traditional channels (i.e., conference papers, workshops).
Dissemination of project results will be largely possible through the project website, delivering all documents produced
during the project lifecycle. This website in particular will be accessible by all partners and also by the project reviewer at
different permission levels. This will make dissemination easier and the number of users increase by allowing for the best
cooperation among Partners, strengthened by the multi-language feature of the website.`}</p>
    </PageDescription>
    <Mermaid name="WP1 Gantt Chart" chart={wp5} config={{
      theme: 'default'
    }} mdxType="Mermaid" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      